import React, { useEffect } from 'react';
import styles from "./Hero.module.scss";
import vid from "../../images/video3.mp4";
import Aos from "aos";
import "aos/dist/aos.css";
import { useLocation, useNavigate } from "react-router-dom";



const Hero = () => {
  useEffect(() => {
    Aos.init({ duration: 1000 });
  }, []);

  const navigate = useNavigate();
  const location = useLocation();

  const handleNavigation = (sectionId) => {
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => {
        document.getElementById(sectionId)?.scrollIntoView({ behavior: "smooth" });
      }, 100);
    } else {
      document.getElementById(sectionId)?.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section className={styles.hero} role="region" aria-label="Hero sekcija">
      <video 
        autoPlay 
        loop 
        muted 
        playsInline 
        className={styles.videoBg} 
        preload="metadata"
        // poster={poster} <!-- Dodajte placeholder sliku -->
      >
        <source src="/path/to/video3.webm" type="video/webm"/>
        <source src={vid} type="video/mp4"/>
      </video>
      <div className={styles.overlay}></div>
      <div data-aos={"fade-up"} className={styles.content}>
        <h1 style={{ 
          fontFamily: "Gealova, serif", 
          fontSize: "2.5rem", 
          fontWeight: "normal", 
          marginBottom: "30px", 
          textAlign: "center" 
        }}>
          Pronađi<br/><span style={{ fontFamily: "Gealova, serif", color: "#d8b66f" }}>slobodu</span><br/>u pokretu
        </h1>
        <a className={styles.button} onClick={() => handleNavigation("kontakt")} role="button" tabIndex="0">
          Pleši sa nama
        </a>
      </div>
    </section>
  );
};

export default Hero;